import type { TipperCreatePayload } from "@/customTypings/tipper/Tipper";
import type { TipperDeletedRestoreAvailableConflict } from "@/utils/tipper/tipperCreateConflict";
import {
    TIPPER_CREATE_CONFLICT,
    TipperCreateConflictError,
    isTipperDeletedRestoreAvailableConflict,
} from "@/utils/tipper/tipperCreateConflict";
import { createPayloadSpreadRestoreConfig } from "./createPayloadSpreadRestoreConfig";

export function createTipperRestoreConfig<TDetail extends { id: string }>(options: {
    restoreDeletedWithCreateValues: (payload: TipperCreatePayload & { id: string }) => Promise<TDetail>;
    onRestored: (detail: TDetail) => void;
}) {
    return createPayloadSpreadRestoreConfig<
        TipperDeletedRestoreAvailableConflict,
        TipperCreatePayload,
        TipperCreatePayload & { id: string },
        TDetail,
        TipperCreateConflictError
    >({
        ConflictErrorClass: TipperCreateConflictError,
        isRestoreAvailable: isTipperDeletedRestoreAvailableConflict,
        deletedRestoreAvailableCode: TIPPER_CREATE_CONFLICT.deletedRestoreAvailable,
        modalTitle: "Restore deleted tipper?",
        modalBody: () =>
            "A deleted tipper matching these details already exists. Restore it using the details you entered?",
        successLabel: (conflict) => conflict.existingName,
        restoreDeletedWithCreateValues: options.restoreDeletedWithCreateValues,
        onRestored: (detail) => options.onRestored(detail),
    });
}
